import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { Table } from 'reactstrap';
import { TenantPicker } from '../../components/selectors/TenantPicker';
import { WarehousePicker } from '../../components/selectors/WarehousePicker';
import { PageHeading } from '../../layouts/PageHeading';
import { StatusBadge } from '../../components/StatusBadge';
import { EmptyState } from '../../components/EmptyState';
import { useListDialogTemplates } from '../../api/dialogTemplates';

export function DialogTemplatesList() {
  const [search] = useSearchParams();
  const navigate = useNavigate();
  const auth = useAuth();
  const token = auth.user?.access_token ?? null;
  const [tenantId, setTenantId] = useState<number | null>(search.get('tenant') ? Number(search.get('tenant')) : null);
  const [warehouseId, setWarehouseId] = useState<number | null>(search.get('warehouse') ? Number(search.get('warehouse')) : null);
  const { data, isLoading } = useListDialogTemplates(warehouseId, token);
  const items = data?.items ?? [];

  const updateUrl = (t: number | null, w: number | null) => {
    const p = new URLSearchParams();
    if (t !== null) p.set('tenant', String(t));
    if (w !== null) p.set('warehouse', String(w));
    navigate({ search: p.toString() }, { replace: true });
  };

  return (
    <div>
      <PageHeading
        scope="Dialog templates"
        meta={<span>Prompt FSM, retry policy, custom commands. Versionati e immutabili.</span>}
        actions={
          <button
            type="button"
            className="btn btn-primary btn-sm"
            disabled={tenantId === null || warehouseId === null}
            onClick={() => navigate(`/admin/dialog-templates/new?tenant=${tenantId}&warehouse=${warehouseId}`)}
          >
            + Nuova versione
          </button>
        }
      />
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <TenantPicker value={tenantId} onChange={(t) => { setTenantId(t); setWarehouseId(null); updateUrl(t, null); }} />
        <WarehousePicker tenantId={tenantId} value={warehouseId} onChange={(w) => { setWarehouseId(w); updateUrl(tenantId, w); }} />
      </div>

      {warehouseId === null ? (
        <EmptyState icon={<i className="bi bi-funnel" />} title="Seleziona tenant e warehouse" body="La lista è per warehouse." />
      ) : isLoading ? (
        <div style={{ padding: 24, color: 'var(--vp-text-3)' }}>Caricamento…</div>
      ) : items.length === 0 ? (
        <EmptyState icon={<i className="bi bi-chat-square-dots" />} title="Nessun dialog template" body="Crea la prima versione." cta={{
          label: '+ Nuova versione',
          onClick: () => navigate(`/admin/dialog-templates/new?tenant=${tenantId}&warehouse=${warehouseId}`),
        }} />
      ) : (
        <div className="table-responsive">
        <Table className="table-hover align-middle table-striped mb-0">
          <thead><tr><th>Version</th><th>Stato</th><th>Lingua</th><th>Voice TTS</th><th>Prompts</th><th>Commands</th><th>Created</th><th></th></tr></thead>
          <tbody>
            {items.map((t) => (
              <tr key={t.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/admin/dialog-templates/${t.id}?tenant=${tenantId}&warehouse=${warehouseId}`)}>
                <td className="font-monospace">v{t.version}</td>
                <td>{t.is_active ? <StatusBadge tone="success">attiva</StatusBadge> : <StatusBadge>prev</StatusBadge>}</td>
                <td>{t.language}</td>
                <td className="font-monospace" style={{ fontSize: 11 }}>{t.voice_tts ?? '—'}</td>
                <td>{Object.keys(t.prompts).length}</td>
                <td>{Object.keys(t.commands).length}</td>
                <td className="font-monospace">{t.created_at.slice(0, 10)}</td>
                <td>→</td>
              </tr>
            ))}
          </tbody>
        </Table>
        </div>
      )}
    </div>
  );
}

export default DialogTemplatesList;
